import styled, { css } from "styled-components"

const chooseImages = ({ useGoogleImages, useTidalImages, useUniVisionImages, useTVisionImages, usePhiloImages, useThankyouImage, useThankyouImageMob, useParamountImages, useOomaImages, useAaaImages }) => {

  let desktopUrl = "/images/default_thanks_desktop.jpg"
  let mobileUrl = "/images/default_thanks_mobile.jpg"
  if (useTVisionImages) {
    desktopUrl = "/images/TVision/thanks_desktop.jpg"
    mobileUrl = "/images/TVision/thanks_mobile.jpg"
  } else if (usePhiloImages) {
    desktopUrl = "/images/Philo/thanks_desktop.jpg"
    mobileUrl = "/images/Philo/thanks_mobile.jpg"
  } else if (useParamountImages) {
    desktopUrl = "/images/Paramount/thanks_desktop.jpg"
    mobileUrl = "/images/Paramount/thanks_mobile.jpg"
  } else if (useThankyouImage) {
    desktopUrl = "data:image/jpeg;base64," + useThankyouImage
    mobileUrl = "data:image/jpeg;base64," + useThankyouImageMob
  } else if (useUniVisionImages) {
    desktopUrl = "/images/Univision/Univision_ThankYouPage_Desktop.jpg"
    mobileUrl = "/images/Univision/Univision_ThankYouPage_Mobile.jpeg"
  } else if (useOomaImages) {
    desktopUrl = "/images/Ooma/landing_desktop_2.jpg"
    mobileUrl = "/images/Ooma/landing_mobile_2.jpg"
  } else if (useAaaImages) {
    desktopUrl = "/images/AAA/TM_Thanks-1240x500-couple.jpeg"
    mobileUrl = "/images/AAA/TM_Thanks-723x600-couple.jpeg"
  } else if (useGoogleImages) {
    desktopUrl = "/images/Google/google-thank.desktop.jpg"
    mobileUrl = "/images/Google/google-thank.mobile.jpg"
  } else if (useTidalImages) {
    desktopUrl =  "/images/Tidal/Thanks_Desktop.png"
    mobileUrl =   "/images/Tidal/Thanks_Mobile.png"
  }

  return { desktopUrl, mobileUrl }
}
export const ThankYouSection = styled.section`
  ${(props) => {
    const { desktopUrl, mobileUrl } = chooseImages(props)
    return css`
      background-image: url(${mobileUrl});
      background-repeat: no-repeat;
      background-position: top center;
      background-size: cover;
      @media (min-width: 768px) {
        background-image: url(${desktopUrl});
      }
    `
  }}
  `
